import { render, staticRenderFns } from "./PdfGeneratorWidget.vue?vue&type=template&id=ef750aa6&"
import script from "./PdfGeneratorWidget.vue?vue&type=script&lang=js&"
export * from "./PdfGeneratorWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
